import { BaseRouteService } from "core/services";

class WoundPatientRouteService extends BaseRouteService {
    constructor() {
        super("woundPatients");
    }

    find(filter) {
        return super.find(
            this.base + "/{?searchQuery,page,rpp,sort,embed,fields}",
            filter
        );
    }

    get(id, options) {
        return super.get(this.base + "/{id}/{?embed,fields}", id, options);
    }

    update(resource) {
        return super.update(this.base + "/{id}", resource);
    }

    delete(resource) {
        return super.delete(this.base + "/{id}", resource);
    }

    create(resource) {
        return super.create(this.base, resource);
    }
}

export default WoundPatientRouteService;
